// extracted by mini-css-extract-plugin
export var callToAction = "ChampionshipDetails-module--callToAction--f6807";
export var card = "ChampionshipDetails-module--card--65ad8";
export var championshipSection = "ChampionshipDetails-module--championshipSection--dc2ec";
export var container = "ChampionshipDetails-module--container--bfc99";
export var description = "ChampionshipDetails-module--description--00b17";
export var featureCard = "ChampionshipDetails-module--featureCard--b3eba";
export var featureIcon = "ChampionshipDetails-module--featureIcon--5c345";
export var featureTitle = "ChampionshipDetails-module--featureTitle--28323";
export var features = "ChampionshipDetails-module--features--835d2";
export var title = "ChampionshipDetails-module--title--0a66e";